import { PREFIX } from './base';

export const ARC_TRANSFORM_VALUE = `${PREFIX}_ARC_TRANSFORM_VALUE`;
export const ARC_RATIO = `${PREFIX}_ARC_RATIO`;
export const ARC_START_ANGLE = `${PREFIX}_ARC_START_ANGLE`;
export const ARC_END_ANGLE = `${PREFIX}_ARC_END_ANGLE`;
export const ARC_K = `${PREFIX}_ARC_K`;
export const ARC_MIDDLE_ANGLE = `${PREFIX}_ARC_MIDDLE_ANGLE`;
export const ARC_QUADRANT = `${PREFIX}_ARC_QUADRANT`;
export const ARC_RADIAN = `${PREFIX}_ARC_RADIAN`;

export const POLAR_START_RADIAN = -Math.PI / 2;
export const POLAR_END_RADIAN = (3 * Math.PI) / 2;

export const POLAR_START_ANGLE = -90;
export const POLAR_END_ANGLE = 270;

export const POLAR_DEFAULT_RADIUS = 0.6;
